import { takeLatest } from "redux-saga/effects";
import * as ActionsTypes from "../../../common/state/StateConstants";
import {
  authenticateSaga,
  getCategoriesSaga,
  getGroupesContingentSaga,
  searchDemandesSaga,
  getEtatsSaga,
  getNomenclaturesSaga,
  getImportateursSaga,
  searchAllDemandesSaga,
  getPaysOrigineSaga,
  downloadDocumentSaga,
  getDfdMarchandisesSaga,
  getDfdDocumentsSaga,
  getDfdDecisionsSaga,
  getDfdByIdSaga,
  fetchHistoriqueSaga,
  downloadDemandeDocument,
  getDecisionTypeSaga,
  getUniteDouniereSaga,
  getUniteCompSaga,
  transferDfdSaga,
  getDepartmentsSaga,
  DecisionMceDfdSaga,
  DecisionDepDfdSaga,
  getNomenclaturesGroupeSaga,
  getSelectedDepartmentsSaga,
  getFixedDfdDecisionSaga,
  getDFDColumnsDensityStateSaga,
  postChangePasswordSaga,
  fetchKpiDfdSaga,
  updateDfdDateFinValiditeSaga,
  registerMFASaga,
  sendOtpMailSaga,
} from "./DfdSaga";

export default function* dfdWatcher() {
  yield takeLatest(ActionsTypes.SEARCH_DEMANDE, searchDemandesSaga);
  yield takeLatest(ActionsTypes.SEARCH_ALL_DEMANDES, searchAllDemandesSaga);
  yield takeLatest(ActionsTypes.AUTHENTICATE_USER, authenticateSaga);
  yield takeLatest(ActionsTypes.FETCH_CATEGORIES, getCategoriesSaga);
  yield takeLatest(ActionsTypes.REGISTER_MFA, registerMFASaga);
  yield takeLatest(ActionsTypes.SEND_OTP_MAIL, sendOtpMailSaga);
  yield takeLatest(ActionsTypes.FETCH_ETATS, getEtatsSaga);
  yield takeLatest(
    ActionsTypes.FETCH_GROUPES_CONTINGENT,
    getGroupesContingentSaga
  );
  yield takeLatest(ActionsTypes.FETCH_NOMENCLATURES, getNomenclaturesSaga);
  yield takeLatest(ActionsTypes.FETCH_IMPORTATEURS, getImportateursSaga);
  yield takeLatest(ActionsTypes.FETCH_PAYS_ORIGINE, getPaysOrigineSaga);
  yield takeLatest(ActionsTypes.FETCH_DFD, getDfdByIdSaga);
  yield takeLatest(ActionsTypes.FETCH_DFD_DECISIONS, getDfdDecisionsSaga);
  yield takeLatest(ActionsTypes.FETCH_DFD_DOCUMENTS, getDfdDocumentsSaga);
  yield takeLatest(ActionsTypes.FETCH_DFD_MARCHANDISES, getDfdMarchandisesSaga);
  yield takeLatest(ActionsTypes.DOWNLOAD_DEMAND, downloadDocumentSaga);
  yield takeLatest(
    ActionsTypes.DOWNLOAD_DEMAND_DOCUMENT,
    downloadDemandeDocument
  );
  yield takeLatest(ActionsTypes.FETCH_HISTORIQUE_DFD, fetchHistoriqueSaga);
  yield takeLatest(ActionsTypes.FETCH_TYPE_DECISION, getDecisionTypeSaga);
  yield takeLatest(ActionsTypes.FETCH_TYPE_DOUNIERE, getUniteDouniereSaga);
  yield takeLatest(ActionsTypes.FETCH_UNIT_COMP, getUniteCompSaga);
  yield takeLatest(ActionsTypes.FETCH_DEPARTMENTS, getDepartmentsSaga);
  yield takeLatest(ActionsTypes.TRANSFER_DFD, transferDfdSaga);
  yield takeLatest(ActionsTypes.DECISION_MCE_DFD, DecisionMceDfdSaga);
  yield takeLatest(ActionsTypes.DECISION_DEP_DFD, DecisionDepDfdSaga);
  yield takeLatest(
    ActionsTypes.FETCH_NOMENCLATURES_GROUP,
    getNomenclaturesGroupeSaga
  );
  yield takeLatest(
    ActionsTypes.SELECTED_DEPARTMENT,
    getSelectedDepartmentsSaga
  );
  yield takeLatest(
    ActionsTypes.GET_FIXED_DFD_DECISION,
    getFixedDfdDecisionSaga
  );
  yield takeLatest(
    ActionsTypes.GET_DFD_COLUMNS_DENSITY_STATE,
    getDFDColumnsDensityStateSaga
  );
  yield takeLatest(ActionsTypes.POST_CHANGE_PASSWORD, postChangePasswordSaga);
  yield takeLatest(ActionsTypes.DFD_KPI, fetchKpiDfdSaga);
  yield takeLatest(
    ActionsTypes.UPDATE_DFD_DATE_FIN_VALIDITE,
    updateDfdDateFinValiditeSaga
  );
}
